<template>
  <v-container fluid>
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('users.listTitle')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="$t('general.search')"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-card-title>
      <data-table
        :items="formatedUsersList"
        :headers="usersHeaders"
        :loading="usersLoading"
        :search="search"
        @selected="(value) => selected = value"
        @edit="editSelection"
      ></data-table>
    </v-card>
    <v-fab-transition>
      <v-btn v-if="showAddButton" fab dark color="primary" bottom right fixed @click.native="editMode = 'add'; editDialog = true">
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        fab
        dark
        color="red"
        bottom
        right
        fixed
        @click.native="deleteDialog = true"
        style="right: 80px;"
        v-if="selected.length > 0"
        >
        <v-icon dark>delete</v-icon>
      </v-btn>
    </v-fab-transition>
    <user-edit :mode="editMode" :active="editDialog" :id="userId" @closedialog="editDialog = false; userId = null"></user-edit>
    <confirmation-dialog :active="deleteDialog" title="Confirmation ?" :message="$tc('users.deleteConfirmation', selected.length, {count: selected.length})" :loading="usersLoading" @confirmation="deleteUsers" @cancel="deleteDialog = false"></confirmation-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DataTable from "@/components/DataTable";
import UserEdit from "./User-edit"
import ConfirmationDialog from "@/components/ConfirmationDialog"

export default {

  name: "Users",

  components: {
    DataTable,
    UserEdit,
    ConfirmationDialog
  },

  data() {
    return {
      showAddButton: false,
      search: "",
      selected: [],
      editDialog: false,
      deleteDialog: false,
      userId: "",
      editMode: "add"
    };
  },

  mounted() {
    this.getAllUsers();
    setTimeout(() => this.showAddButton = true, 500)
  },

  methods: {

    editSelection(value) {
      this.editMode = 'edit'
      this.userId = value
      this.editDialog = true
    },

    async deleteUsers() {
      if (await this.deleteUsersAction(this.selected.map(item => item._id))){
        this.deleteDialog = false
        this.selected = []
      }
    },

    ...mapActions('users', {
      getAllUsers: 'getAll',
      deleteUsersAction: 'delete'
    })

  },
  computed: {

    formatedUsersList () {
      return this.allUsers.filter((user) => {
        if (this.user.role < 3 && user.role === 3) return false
        return true
      }).map(user => {
        user.roleName = this.usersRoles[user.role - 1].name
        return user 
      })
    },

     ...mapGetters('users', {
      allUsers: 'list',
      usersRoles: 'roles',
      usersHeaders: 'headers',
      usersLoading: 'loading'
    }),

    ...mapGetters('user', {
      user: 'current'
    })

  }
};
</script>
